@if (images && isVisisble) {
  <div id="imageModal" style="z-index: 9999999;"
    class="fixed inset-0 w-full h-full bg-gray-900/80 flex justify-center items-center">
    <!-- Close Button in Top Right with Padding -->
    <button class="absolute top-4 right-4 p-4 text-white bg-gray-800 rounded-full" (click)="hideModal()">
      Fechar &times;
    </button>
    @if (!previewLoadFailed) {
      <img class="object-cover max-h-[90vh] max-w-[90vw]" [src]="images[0]" alt="Current Image"
           (error)="previewLoadFailed = true">
    } @else {
      <div
        class="flex max-h-[90vh] max-w-[90vw] flex-col items-center justify-center rounded-lg bg-slate-800 px-16 py-12 text-slate-300">
        <i class="pi pi-image mb-4 text-8xl opacity-70"></i>
        <span class="text-sm">Imagem indisponível</span>
      </div>
    }
  </div>
}
